export default {
  consult: {},
  agenda: {},
  documentsConsulted: [],
  consult_view_version: 'new',
};
